exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#buttons[data-v-08019e22] {\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n/* Page content */\n.content[data-v-08019e22] {\n  padding: 16px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-08019e22","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/entities/document/document-show.vue
// module id = F9zM
// module chunks = 1